"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeDataPropsInterface = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var UpgradeProducts = _interopRequireWildcard(require("self-service-api/constants/UpgradeProducts"));

var upgradeDataPropsInterface = {
  upgradeData: _propTypes.default.shape({
    app: _propTypes.default.string,
    screen: _propTypes.default.string,
    upgradeProduct: _propTypes.default.oneOf(Object.values(UpgradeProducts))
  })
};
exports.upgradeDataPropsInterface = upgradeDataPropsInterface;